var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.formContainer },
    [
      _c(
        "transitionGroup",
        {
          attrs: {
            enterClass: _vm.$style.fadeEnter,
            enterActiveClass: _vm.$style.fadeEnterActive,
            leaveActiveClass: _vm.$style.fadeLeaveActive,
            leaveToClass: _vm.$style.fadeLeaveTo,
          },
        },
        [
          !_vm.success
            ? _c(
                "LoginCard",
                { key: "form", attrs: { header: "Register Your Account" } },
                [
                  _c("LoginAlert", {
                    model: {
                      value: _vm.errorMessage,
                      callback: function ($$v) {
                        _vm.errorMessage = $$v
                      },
                      expression: "errorMessage",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "form",
                    [
                      _c("LoginTextField", {
                        attrs: {
                          autocomplete: false,
                          label: "First Name",
                          name: "firstName",
                          placeholder: "First Name",
                          isEditable: _vm.readOnly !== "true",
                          rules: { required: true },
                          submitOnEnter: _vm.submit,
                          vvName: "first name",
                        },
                        model: {
                          value: _vm.form.firstName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "firstName", $$v)
                          },
                          expression: "form.firstName",
                        },
                      }),
                      _vm._v(" "),
                      _c("LoginTextField", {
                        attrs: {
                          autocomplete: false,
                          label: "Last Name",
                          name: "lastName",
                          placeholder: "Last Name",
                          isEditable: _vm.readOnly !== "true",
                          rules: { required: true },
                          submitOnEnter: _vm.submit,
                          vvName: "last name",
                        },
                        model: {
                          value: _vm.form.lastName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "lastName", $$v)
                          },
                          expression: "form.lastName",
                        },
                      }),
                      _vm._v(" "),
                      _c("LoginTextField", {
                        attrs: {
                          autoFocus: true,
                          autocomplete: false,
                          label: "Password",
                          name: "password",
                          placeholder: "Password",
                          type: "password",
                          rules: { max: 64, required: true },
                          submitOnEnter: _vm.submit,
                          vvName: "password",
                        },
                        model: {
                          value: _vm.form.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "password", $$v)
                          },
                          expression: "form.password",
                        },
                      }),
                      _vm._v(" "),
                      _c("LoginTextField", {
                        attrs: {
                          autocomplete: false,
                          label: "Confirm Password",
                          name: "confirm",
                          placeholder: "Confirm Password",
                          submitOnEnter: _vm.submit,
                          rules: { max: 64, required: true },
                          type: "password",
                          vvName: "confirm password",
                        },
                        model: {
                          value: _vm.form.confirm,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "confirm", $$v)
                          },
                          expression: "form.confirm",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "LoginActionButton",
                        {
                          attrs: {
                            action: _vm.submit,
                            isLoading: _vm.isLoading,
                          },
                        },
                        [_vm._v("\n          Register\n        ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.success
            ? _c(
                "div",
                { key: "confirmation" },
                [
                  _c("h2", { class: _vm.$style.header }, [
                    _vm._v("\n        Thank You\n      "),
                  ]),
                  _vm._v(" "),
                  _c("h5", { class: _vm.$style.subheader }, [
                    _c("div", [_vm._v("Account activation successful.")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "You may now log in to the JumpCloud User Portal."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "LoginActionButton",
                    { attrs: { action: _vm.continueAction } },
                    [_vm._v("\n        continue to login\n      ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("LogoIcon"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }